import get from 'lodash.get';
import { emptyArray } from 'ui-components/default-props/empty';
import * as Actions from '../../store/bulk/bulk.actions';
import * as ReturnActions from '../../store/returns/returns.actions';
import * as RefreshTrackingActions from '../../store/refresh-tracking/refresh-tracking.actions';
import * as BatchDetailActions from '../../store/batches/details/batch.details.actions';
import * as MarkAsShippedActions from '../../store/mark-as-shipped/mark-as-shipped.actions';
import { addLabelBatchToLabelQue, getLabelQueBatchesRequest } from '../../store/label-que/label-que.actions';
import { addLabelBatchStatusModalBatch } from '../../store/batches/label-batch-status-modal/batches.label-batch-status-modal.actions';
import { QuickShipService } from '../../services/quick-ship-service';
import { LogService } from '../../services/log-service';
import { LABEL_SERVICE_BATCH_STATUS_IDS } from '../../constants/label-batch-status-ids';
import { BATCH_PROGRESS } from '../../services/pusher-service/pusher-contract-messages';
import { labelBatchListener } from '../../services/pusher-service/persistent-listeners';
import { checkLabelBatchIsComplete } from './helpers';

export const LABEL_SERVICE_BATCH_FILL_METHOD_IDS = {
  SHIPMENT: 1,
  FULFILLMENT: 2,
};

const CONNECT_BATCH_PROGRESS = {
  eventName: BATCH_PROGRESS,
  actionToDispatch: (pusherMessage) => {
    const totalLabelCount = get(pusherMessage, 'status.Total', 0);
    const completedLabelCount = get(pusherMessage, 'status.Completed', 0);
    const erroredLabelCount = get(pusherMessage, 'status.Errors', 0);

    const hasErrors = get(pusherMessage, 'status.Errors', 0) > 0;

    const notifyingMarketPlace = checkLabelBatchIsComplete(pusherMessage);
    const canShowLabel = totalLabelCount === completedLabelCount + erroredLabelCount;
    const hasStatusUpdated = get(pusherMessage, 'status.StatusUpdated', false);
    const batchId = get(pusherMessage, 'status.BatchID', null);
    const fillMethod = get(pusherMessage, 'status.FillMethod');
    const isFulfillment = fillMethod === LABEL_SERVICE_BATCH_FILL_METHOD_IDS.FULFILLMENT;
    const isCompleteFulfillment = isFulfillment && get(pusherMessage, 'status.StatusID') === LABEL_SERVICE_BATCH_STATUS_IDS.COMPLETED;

    const actions = [];
    const isComplete = pusherMessage.isBatchComplete;
    const labelBatch = QuickShipService.formLabelQueBatchFromPusherMessage(pusherMessage, isComplete);
    if (!hasStatusUpdated) {
      actions.push(addLabelBatchToLabelQue(labelBatch));
      actions.push(addLabelBatchStatusModalBatch(labelBatch));
    }
    const userId = pusherMessage?.status?.UserID || '';
    if (isComplete) {
      actions.push(getLabelQueBatchesRequest(userId));
      actions.push(addLabelBatchStatusModalBatch(labelBatch));
    }

    if (canShowLabel && (notifyingMarketPlace || isCompleteFulfillment)) {
      if (hasErrors) {
        actions.push(Actions.bulkProcessingUnknownError(batchId, pusherMessage));
        return actions;
      }

      if (userId === LogService.metadata?.metadata?.userGuid) {
        LogService.logInfo('final label batch pusher message received', {
          labelBatchId: batchId,
          statusId: pusherMessage?.status?.StatusID,
          totalLabelCount,
          completedLabelCount,
          erroredLabelCount,
          isFulfillment,
          utcTimestamp: new Date().toISOString(),
        });
      }
      actions.push(Actions.createLabelBatchLastMessage(batchId, pusherMessage));
      return actions;
    }

    if (hasStatusUpdated) {
      actions.push(MarkAsShippedActions.markShippedPusherMessage(batchId));
      return actions;
    }
    actions.push(Actions.messageReceivedCreateLabel(pusherMessage));
    return actions;
  },
  persistentTrigger$: labelBatchListener.persistentTrigger$,
};

const CONNECT_RETURN_LABEL_PROCESSING = {
  eventName: 'bulk-action:returnLabelEmail',
  actionToDispatch: (pusherMessage) => {
    const statuses = get(pusherMessage, 'data', emptyArray);
    const failures = statuses.filter((msg) => msg.error !== null);
    if (failures.length > 0) {
      return ReturnActions.processingReturnLabelsEmailFailure(failures);
    }
    return ReturnActions.processingReturnLabelsEmailSuccess(statuses);
  },
};

const CONNECT_REFRESH_TRACKING = {
  eventName: 'bulk-action:refreshTracking',
  actionToDispatch: (pusherMessage) => {
    const jobGuid = get(pusherMessage, 'messageGuid', '');
    return RefreshTrackingActions.refreshTrackingSuccess(jobGuid, pusherMessage);
  },
};

const CONNECT_EMAIL_NOTIFICATION = {
  eventName: 'send_confirmation_email',
  actionToDispatch: (pusherMessage) => {
    const jobGuid = get(pusherMessage, 'messageGuid', '');
    return BatchDetailActions.shipmentNotificationMessage(jobGuid, pusherMessage);
  },
};

export const ConnectBatchEvents = [
  CONNECT_BATCH_PROGRESS,
  CONNECT_RETURN_LABEL_PROCESSING,
  CONNECT_REFRESH_TRACKING,
  CONNECT_EMAIL_NOTIFICATION,
];
